import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/table-scrolling.css";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Enable better HMR support in development
if (import.meta.hot) {
  import.meta.hot.accept();
}
